import React from "react";

// Recurso único centralizado para el logo de la aplicación (Entradasdeportivas).
// Se mantiene la proporción cuadrada del logo. Solo se controla el tamaño desde fuera.
export default function AppLogo({ size = 40, className = "", rounded = true, alt = "Entradasdeportivas" }) {
  return (
    <img
      src="/sport-plus-logo.png"
      alt={alt}
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain" }}
      className={`${rounded ? "rounded-full bg-white" : ""} ${className}`.trim()}
      data-testid="app-logo"
      draggable={false}
    />
  );
}
